import { render, staticRenderFns } from "./requirement.vue?vue&type=template&id=32924693&scoped=true"
import script from "./requirement.vue?vue&type=script&lang=js"
export * from "./requirement.vue?vue&type=script&lang=js"
import style0 from "./requirement.vue?vue&type=style&index=0&id=32924693&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32924693",
  null
  
)

export default component.exports